import { useState, useEffect } from "react";

import { Input, Button } from "@fragments";

import { AccountBalanceRounded } from "@mui/icons-material";

import Section from "../Section";

const keyTypes = [
    { value: 'email', label: 'Email' },
    { value: 'phone', label: 'Telefone' },
    { value: 'cpf', label: 'CPF' },
    { value: 'cnpj', label: 'CNPJ' },
    { value: 'evp', label: 'Chave aleatória' }
];

export default function IncomingBankAccount({ REF_values }) {
    const [keyType, setKeyType] = useState(REF_values.current.withdrawal?.keyType || 'email');
    const [pixKey, setPixKey] = useState(REF_values.current.withdrawal?.key || '');

    useEffect(() => {
        REF_values.current.withdrawal.keyType = keyType;
    }, [keyType]);

    useEffect(() => {
        REF_values.current.withdrawal.key = pixKey;
    }, [pixKey]);

    function KeyTypeButton({ value, label }) {
        return (
            <Button
                color={keyType === value ? 'primary' : 'overlay'}
                text={label}
                size="small"
                onClick={() => {
                    setKeyType(value);
                    setPixKey('');
                }}
            />
        );
    }

    function renderPixKeyInput() {
        switch (keyType) {
            case 'phone':
                return (
                    <Input.Phone
                        className="mt-1"
                        label="Insira o número de telefone"
                        value={pixKey}
                        onInput={setPixKey}
                    />
                );
            case 'cpf':
                return (
                    <Input.CPF
                        className="mt-1"
                        label="Insira o CPF"
                        value={pixKey}
                        onInput={setPixKey}
                    />
                );
            case 'cnpj':
                return (
                    <Input.CNPJ
                        className="mt-1"
                        label="Insira o CNPJ"
                        value={pixKey}
                        onInput={setPixKey}
                    />
                );
            case 'email':
                return (
                    <Input.Email
                        className="mt-1"
                        label="Insira o email"
                        value={pixKey}
                        onInput={setPixKey}
                    />
                );
            case 'evp':
            default:
                return (
                    <Input.Text
                        className="mt-1"
                        label="Insira a chave pix aleatória"
                        value={pixKey}
                        onInput={setPixKey}
                    />
                );
        }
    }

    return (
        <>
            <Section
                icon={<AccountBalanceRounded />}
                title="Conta de recebimento"
                description="Informe a chave pix onde você receberá o pagamento das assinaturas."
            >
                <h5 className="bold mb-1">Tipo de chave</h5>
                <div className="key-type-boxes" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {keyTypes.map((type) => (
                        <KeyTypeButton key={type.value} value={type.value} label={type.label} />
                    ))}
                </div>

                <h5 className="bold mt-3 mb-1">Chave pix</h5>
                {renderPixKeyInput()}
            </Section>
        </>
    );
}